import React, { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import type { Equipamento } from '../../../../models';
import { useEquipamentoMutations } from '../../../../hooks/data';

function paraDataHora(timestamp: { toDate: () => Date }): string {
  const data = timestamp.toDate();
  return `${data.toLocaleDateString('pt-BR')} às ${data.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`;
}

/** Comentários com autor e data, em todos os tipos (ex.: motivo de falha, data de
 * manutenção) — mais recentes primeiro. Não se edita nem apaga (é registro). */
export default function AtivoComentarios({ equipamento }: { equipamento: Equipamento }) {
  const { user } = useAuth();
  const { adicionarComentario } = useEquipamentoMutations();
  const [texto, setTexto] = useState('');
  const comentarios = [...(equipamento.comentarios ?? [])].sort(
    (a, b) => b.criadoEm.toMillis() - a.criadoEm.toMillis()
  );

  const enviar = () => {
    if (!user || !texto.trim()) return;
    adicionarComentario.mutate(
      {
        id: equipamento.id,
        texto,
        autor: { id: user.collaboratorId ?? user.uid, name: user.displayName ?? user.email ?? '', avatar: null },
      },
      { onSuccess: () => setTexto('') }
    );
  };

  return (
    <section className="rounded-md border border-gray-200 p-4">
      <p className="text-xs font-semibold uppercase tracking-wide text-gray-400">Comentários</p>
      <div className="mt-2 flex gap-2">
        <textarea
          className="input-primary w-full"
          rows={2}
          placeholder="Ex.: tela com falha, enviado pra manutenção em 15/09..."
          value={texto}
          onChange={(e) => setTexto(e.target.value)}
        />
        <button
          type="button"
          className="btn-secondary h-fit text-sm"
          disabled={!texto.trim() || adicionarComentario.isPending}
          onClick={enviar}
        >
          Adicionar
        </button>
      </div>
      {comentarios.length === 0 ? (
        <p className="mt-2 text-sm text-gray-400">Nenhum comentário.</p>
      ) : (
        <ul className="mt-3 space-y-2">
          {comentarios.map((c) => (
            <li key={c.id} className="rounded-md bg-gray-50 p-2 text-sm">
              <p className="whitespace-pre-wrap text-gray-800">{c.texto}</p>
              <p className="mt-1 text-xs text-gray-400">
                {c.autor?.name || 'Sem autor'} · {paraDataHora(c.criadoEm)}
              </p>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
